import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, OnInit,ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DhlFormControl } from '../../models/dhl-form-control';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-form-field-readonly-v2',
    templateUrl: './form-field-readonly-v2.component.html',
    styleUrls: ['./form-field-readonly-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormFieldReadonlyV2Component implements OnInit {
  commonSubject: any;

  constructor(private appService: AppService, private cd:ChangeDetectorRef) { }
  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();
  setValueToControl(value) {
    if(value)    
    this.frmGroup.get(this.configData.name).setValue(value);
  }
  
  clearFieldValue(){
    this.frmGroup.get(this.configData.name).reset();
  }

  ngOnInit() {
    if (this.configData.events) {
      this.onCommonEventHander( 'CHANGE', null);
    }

    if (this.configData['dynamicVisibility']) {
      if(this.configData['dynamicVisibility'].action == 'hidden'){
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      }
    }

    if (this.configData['editAccess']) {
      this.configData['editAccess'].forEach(row => {
        let persona;
        if(row.roleAccess){
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if(row.action == 'hidden'){
          this.frmGroup.get(this.configData.name)['hidden'] = !this.checkFieldAccess(persona);
        }
      });
    }
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }
  
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }

  onCommonEventHander(eventType, userEvent) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        this.sendToSource(event, userEvent);
        return
      }
    }
  }

    ngAfterViewInit() {
    this.commonSubject = this.appService._commonComponentSubject.subscribe(res => {
      this.cd.detectChanges()
    })
  }

  sendToSource(event, data = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    console.log("eventData:::",eventData);
    this.appService._commonComponentSubject.next(eventData);
  }

   /** Common Method to check event exist in template */
   checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      // event = (event.length ? event[0] : null);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }
}
